import React from 'react';
import { observer } from 'mobx-react';

import { Miscellaneous } from 'apps/shipmentQuote/Miscellaneous/Miscellaneous';
import { ProductQuotesTable } from 'apps/shipmentQuote/QuotePage/ProductQuotesTable/ProductQuotesTable';
import { useAppManager } from 'core/hooks';
import OrderAppManager from 'apps/order/appManager';
import { clientStore } from 'apps/client/app';
import { routerStore } from 'core/routing';
import { Loading } from 'components';
import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from '../../../legacyComponents/styled/lib';

import { OrderHeader } from './OrderHeader';
import { OrderDetails } from './OrderDetails';

import { analytics } from 'core/analytics';

import {
  fromLocalStorage,
  removeLocalStorage
  } from 'core/localStorage';

export const OrderPage = observer(function OrderPage() {
  const orderAppManager = useAppManager(
    OrderAppManager,
    null,
    {
      signedInProfile: clientStore?.signedInProfile,
      orderId: routerStore.route.params.orderId,
    },
    true,
    [clientStore?.signedInProfile, routerStore.route.params.orderId],
  );
  const { order } = orderAppManager;

  if (orderAppManager.loading) {
    return <Loading />;
  }

  const redirectedFromStripe = fromLocalStorage("payingRfq");

  if(redirectedFromStripe && order.quote.id == redirectedFromStripe.quoteId) {
    analytics.sendEvent("payment-confirmation", {quoteId: order.quote.id},{ga:true})
    removeLocalStorage("payingRfq")
  }

  return (
    <MainWrapper marginTop='2rem'>
      <DocumentHead title='Order' />
      <OrderHeader orderAppManager={orderAppManager} />
      <OrderDetails order={order} />
      <ProductQuotesTable productQuotes={order?.quote.productQuotes} />
      <Miscellaneous quote={order?.quote} disableActions={true} />
    </MainWrapper>
  );
});
